import emailjs from "../../../_snowpack/pkg/@emailjs/browser.js";
import React, {useState} from "../../../_snowpack/pkg/react.js";
import Button from "../../../_snowpack/pkg/react-bootstrap/Button.js";
import styles from "./ContactMe.module.css";
const ContactMePage = () => {
  const [stateMessage, setStateMessage] = useState(null);
  const serviceID = "service_y42pl5j";
  const templateID = "template_wimktdp";
  const publicKey = "7Vkh1NI3FAsj6BiDC";
  const sendEmail = (e) => {
    e.persist();
    e.preventDefault();
    console.log(e);
    emailjs.sendForm(serviceID, templateID, e.target, publicKey).then((result) => {
      setStateMessage(result.text);
      setTimeout(() => {
        setStateMessage(null);
      }, 5e3);
    }, (error) => {
      setStateMessage(error);
      setTimeout(() => {
        setStateMessage(null);
      }, 5e3);
    });
    e.target.reset();
  };
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.container
  }, /* @__PURE__ */ React.createElement("header", null, /* @__PURE__ */ React.createElement("div", {
    className: styles.headerContainer
  }, /* @__PURE__ */ React.createElement("h2", {
    className: styles.headerText
  }, "Have a question about a project? Do you need help launching an app or a website? Or do you have any music recommendations? If so, please don’t hesitate to fill this out and I'll try to respond as soon as possible!"))), /* @__PURE__ */ React.createElement("div", {
    className: styles.formContainer
  }, /* @__PURE__ */ React.createElement("form", {
    onSubmit: sendEmail,
    className: styles.form
  }, /* @__PURE__ */ React.createElement("label", {
    className: styles.formName
  }, "Name: "), /* @__PURE__ */ React.createElement("input", {
    type: "text",
    name: "user_name",
    className: styles.formNameContainer
  }), /* @__PURE__ */ React.createElement("label", {
    className: styles.formEmail
  }, "Email Address: "), /* @__PURE__ */ React.createElement("input", {
    type: "email",
    name: "user_email",
    className: styles.formEmailContainer
  }), /* @__PURE__ */ React.createElement("label", {
    className: styles.formComment
  }, "Comments:"), /* @__PURE__ */ React.createElement("textarea", {
    name: "message",
    rows: 3,
    className: styles.formCommentInput
  }), /* @__PURE__ */ React.createElement(Button, {
    className: styles.submitButton,
    variant: "primary",
    type: "submit"
  }, "Submit")), stateMessage && /* @__PURE__ */ React.createElement("p", null, stateMessage)));
};
export default ContactMePage;
